<template>
    <el-dialog
        v-if="visible"
        :visible="visible"
        :show-close="false"
        width="660px"
        :close-on-click-modal="false"
    >
        <div class="dialog">
            <dialogHeader
                :title="actionType == 'add' ? '新增配置' : '编辑配置'"
                @closeDialog="onLeave"
            ></dialogHeader>
            <div class="dialogList">
                <el-form
                    :rules="rules"
                    ref="addObj"
                    :model="addObj"
                    label-width="120px"
                >
                    <el-form-item
                        label="供应商"
                        prop="member_id"
                        v-if="actionType == 'add'"
                    >
                        <el-select
                            v-model="memberType"
                            placeholder="请选择"
                            style="width: 120px"
                            size="small"
                        >
                            <el-option
                                v-for="item in memberTypeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <el-select
                            size="small"
                            v-model="addObj.member_id"
                            filterable
                            remote
                            reserve-keyword
                            :placeholder="`请输入${memberTypeList[memberType].label}搜索用户`"
                            :remote-method="remoteMethod"
                            :loading="selectLoading"
                            style="width: 280px"
                        >
                            <el-option
                                v-for="item in memberList"
                                :key="item.id"
                                :label="item.dname"
                                :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支付模式">
                        <el-radio-group v-model="addObj.type" size="small">
                            <el-radio-button :label="0">公众号</el-radio-button>
                            <el-radio-button :label="1">被扫支付(B扫C)</el-radio-button>
                            <el-radio-button :label="2">二维码主扫(C扫B)</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="公众号支付加密模式">
                        <el-radio-group v-model="addObj.encryption_mode" size="small">
                            <el-radio-button :label="0">md5</el-radio-button>
                            <el-radio-button :label="1">sha256</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="商户号：" prop="merchant_id">
                        <el-input
                            v-model.trim="addObj.merchant_id"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="终端号：" prop="terminal_code">
                        <el-input
                            v-model.trim="addObj.terminal_code"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="消息来源：" prop="msg_src">
                        <el-input
                            v-model.trim="addObj.msg_src"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="来源编号：" prop="msg_src_id">
                        <el-input
                            v-model.trim="addObj.msg_src_id"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="pos支付appid：" prop="appid">
                        <el-input
                            v-model.trim="addObj.appid"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="pos支付appkey：" prop="appkey">
                        <el-input
                            size="small"
                            type="textarea"
                            :autosize="{ minRows: 5, maxRows: 8}"
                            v-model.trim="addObj.appkey"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="MD5密钥：" prop="sign">
                        <el-input
                            size="small"
                            type="textarea"
                            :autosize="{ minRows: 5, maxRows: 8}"
                            v-model.trim="addObj.sign"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div
                slot="footer"
                class="dialog-footer"
                flex="cross:center main:right"
            >
                <el-button size="small" @click="onLeave">取 消</el-button>
                <el-button
                    size="small"
                    type="primary"
                    :loading="addLoading"
                    @click="onSumbit('addObj')"
                >
                    确 定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { editMerchantUnion, addMerchantWeUnion } from "@/api/config";
import { queryMemberByCondition } from "@/api/admin";

export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        actionType: {
            type: String,
            default: "add",
        },
        config: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            rules: {
                member_id: [
                    {
                        required: true,
                        message: "供应商id不能为空",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "支付模式不能为空",
                        trigger: "blur",
                    },
                ],
                encryption_mode: [
                    {
                        required: true,
                        message: "公众号支付加密模式不能为空",
                        trigger: "blur",
                    },
                ],
            },
            addObj: {
                id: "",
                member_id: "", // 关联银联的用户id
                merchant_id: "", // 商户号(公众号)(pos机共用字段)
                terminal_code: "", // 终端号(pos机和公众号共用)
                msg_src: "", // 消息来源
                msg_src_id: "", // 来源编号
                sign: "", // MD5密钥
                appid: "", // pos支付appid
                appkey: "", // pos支付appkey
                type: 0, // 0-公众号 1-pos机 默认0
                encryption_mode: 0, // 公众号支付加密模式 0-md5 1-sha256
            },
            selectLoading: false,
            memberTypeList: [
                {
                    value: 0,
                    label: "账号",
                },
                {
                    value: 1,
                    label: "手机号",
                },
                {
                    value: 2,
                    label: "名称",
                },
            ],
            memberType: 0, // 用户搜索类型
            memberList: [], // 用户列表
            addLoading: false,
        };
    },
    watch: {
        visible(val) {
            if (val) {
                if (this.actionType === "edit" && this.config) {
                    this.addObj = Object.assign({}, this.config);
                }
            } else {
                this.addObj = {
                    id: "",
                    member_id: "", // 关联银联的用户id
                    merchant_id: "", // 商户号(公众号)(pos机共用字段)
                    terminal_code: "", // 终端号(pos机和公众号共用)
                    msg_src: "", // 消息来源
                    msg_src_id: "", // 来源编号
                    sign: "", // MD5密钥
                    appid: "", // pos支付appid
                    appkey: "", // pos支付appkey
                    type: 0, // 0-公众号 1-pos机 默认0
                    encryption_mode: 0, // 公众号支付加密模式 0-md5 1-sha256
                };
            }
        },
    },
    methods: {
        async remoteMethod(val) {
            let pType = {
                0: "account",
                1: "mobile",
                2: "dname",
            };
            let params = {
                page_size: 100,
                [pType[this.memberType]]: val,
            };
            this.selectLoading = true;
            const res = await queryMemberByCondition(params);
            this.selectLoading = false;
            if (res.code != 200) return;
            this.memberList = res.data;
        },
        onLeave() {
            this.$emit("update:visible", false);
        },
        onSumbit(formName) {
            if (this.addLoading) return;
            let { actionType } = this;
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let func = addMerchantWeUnion;
                    let params = {
                      ...this.addObj,
                    };
                    if (actionType == "edit") {
                        func = editMerchantUnion;
                    }
                    this.addLoading = true;
                    const res = await func(params);
                    this.addLoading = false;
                    if (res.code != 200) return this.$message.error(res.msg || "操作失败");
                    this.$message.success(res.msg || "操作成功");
                    this.onLeave();
                    this.$emit("refresh");
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
    },
};
</script>

<style></style>
